import React from 'react'
import { scroller } from 'react-scroll'
import { PromoBannerButton } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'

type Props = {
  kind?: React.ComponentProps<typeof PromoBannerButton>['kind']
  arrowTheme?: React.ComponentProps<typeof PromoBannerButton>['arrowTheme']
}

export const BrowseCertificatesCta = ({ kind, arrowTheme }: Props = {}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <TrackClick event='certificateLandingClick'>
      <PromoBannerButton
        kind={kind}
        arrowTheme={arrowTheme}
        hideTextOnMobile
        onClick={() =>
          scroller.scrollTo('browse-certificates', { duration: 250 })
        }
      >
        {t('marketingPages.hub.hero.cta')}
      </PromoBannerButton>
    </TrackClick>
  )
}
